export const postalCode = (value: string): boolean => /^[1-9][0-9]{3}(?!SA|SD|SS)[A-Z]{2}$/.test(value)
